<template>
  <v-row no-gutters justify="end">
    <v-col shrink>
      <v-select
        light
        :items="sortOptions"
        v-model="sort"
        :label="sortInputLabel"
        :value="sort"
        hide-details
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    sortOptions: {
      type: Array,
      required: true
    },
    selectedSortOption: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      sort: ""
    };
  },
  computed: {
    sortInputLabel() {
      return this.$t("sortDefault");
    }
  },
  created() {
    this.sort = this.selectedSortOption;
  },
  watch: {
    sort() {
      this.$emit("sortupdated", this.sort);
    }
  }
};
</script>
